import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} Infobizz. All rights reserved.
    </footer>
  );
};

export default Footer;
